import * as tslib_1 from "tslib";
import styled, { withProps } from '../styles';
var rowBgColor = {
    light: {
        tableRowSelected: 'rgba(0, 0, 0, 0.04)',
        tableRowHover: 'rgba(0, 0, 0, 0.07)',
    },
    dark: {
        tableRowSelected: 'rgba(255, 255, 255, 0.08)',
        tableRowHover: 'rgba(255, 255, 255, 0.14)',
    },
};
var Tr = withProps()(styled.tr)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  height: ", ";\n  vertical-align: middle;\n  background-color: ", ";\n\n  &:hover {\n    background-color: ", ";\n  }\n"], ["\n  height: ", ";\n  vertical-align: middle;\n  background-color: ",
    ";\n\n  &:hover {\n    background-color: ",
    ";\n  }\n"])), function (props) { return (props.typeHead ? '56px' : '48px'); }, function (props) {
    return props.selected
        ? rowBgColor[props.theme.palette.type].tableRowSelected
        : 'transparent';
}, function (props) {
    return props.typeHead || props.typeFooter
        ? 'transparent'
        : rowBgColor[props.theme.palette.type].tableRowHover;
});
export default Tr;
var templateObject_1;
//# sourceMappingURL=Tr.js.map